export const MOBILE_BREAKPOINT = 499;
export const DESKTOP_BREAKPOINT = 1024;
export const BIG_DESKTOP_BREAKPOINT = 1350;

export const MOBILE_MEDIA_QUERY = `(max-width: ${MOBILE_BREAKPOINT}px)`;
export const DESKTOP_MEDIA_QUERY = `(min-width: ${DESKTOP_BREAKPOINT}px)`;
export const BIG_DESKTOP_MEDIA_QUERY = `(min-width: ${BIG_DESKTOP_BREAKPOINT}px)`;

export const isMobile = (): boolean =>
  typeof window !== 'undefined' && window.matchMedia(MOBILE_MEDIA_QUERY).matches;
